
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/extra",
      function () {
        return require("private-next-pages/locale/extra.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/extra"])
      });
    }
  